import { mapLegacyAccessPromiseToServiceFnPromise } from 'app/services/http/utils'
import { getCurrentOwners } from 'app/sm/inspections/inspections_access'

export const getPropertyOwners = (teamId, propertyId) => {
  return mapLegacyAccessPromiseToServiceFnPromise(
    getCurrentOwners(teamId, propertyId),
  )
}
